import { Flex, Text } from '@frontend/legacy-components';

const controlTextProps = {
  fontSize: 'sm' as const,
  lineHeight: 'short' as const,
};

export const ViewerControlsInfoRow = ({
  title,
  value,
}: {
  title: string;
  value: string;
}) => (
  <Flex alignItems="flex-start" gap={3} justify="space-between" w="100%">
    <Text flex="1" fontWeight="medium" minW={0} {...controlTextProps}>
      {title}
    </Text>
    <Text flex="1" minW={0} {...controlTextProps}>
      {value}
    </Text>
  </Flex>
);
ViewerControlsInfoRow.displayName = 'ViewerControlsInfoRow';
